import React, { useState } from "react"
import { GetApp } from "../../App"
import { BlockRow, BlockField, BlockFieldInputs } from "../../Components/Block"
import { NumberInput } from "../../Components/Input"
import { LocalizedMessage } from "../../Components/LocalizedMessage"
import { InfoDialog } from "../../Components/InfoDialog"
import { IShipSettings } from "../../Types"

interface LogOffsetSettingViewProps {
  settings: IShipSettings;
  onEditEvent: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

// Log-offset section of the settings tab.
export function LogOffsetSettingView({ settings, onEditEvent }: LogOffsetSettingViewProps) {
  const app = GetApp()!;
  const t = app.getT("ShipSettingsView");
  const [showLogOffsetInfo, setShowLogOffsetInfo] = useState(false);

  return (
    <>
      <hr></hr>
      <BlockRow>
        <h3 className="block-row-followed-by-block-row">{t("log_offset_title")}</h3>
      </BlockRow>

      <BlockRow className="block-row-one-row align-items-end">
        <BlockField label={t("log_offset")} className="block_field_small_12">
          <BlockFieldInputs>
            <NumberInput format="float" name="logOffset" defaultValue={settings?.logOffset ?? ""} placeholder="0" onChange={onEditEvent} />
          </BlockFieldInputs>
        </BlockField>

        {/* Button for more info */}
        <BlockField label=" " className="">
          <button type="button" className="button" onClick={() => setShowLogOffsetInfo(true)}>
            <span className="question-circle">?</span>  {t("more_info")}
          </button>
        </BlockField>

      </BlockRow>
      {showLogOffsetInfo && (
        <InfoDialog
          title={t("log_offset_title")}
          message={<LocalizedMessage message={(m) => m.shipSetting.log_offset} />}
          onClose={() => setShowLogOffsetInfo(false)}
          style="info"
        />
      )}
    </>
  );
}
